import { mergeStyles } from '@uifabric/merge-styles'
import React from 'react'
import { SpanningBar } from './spanning_bar'

const style = mergeStyles({
    display: 'flex',
    justifyContent: 'center',
    'selectors': {
        'div': {
            marginLeft: 16,
        },
        'div:first-child': {
            marginLeft: 0,
        }
    },
    '@media(max-width: 900px)': {
        fontSize: 12,
    }
})

export const Footer = () => (
    <SpanningBar extendedStyle={{
        position: 'fixed',
        bottom: '0%',
        width: '100%',
    }}>
        <div className={style}>
            <div>Copyright © 2021 Chris Luttio</div>
            <div>•</div>
            <div>Icons made by <a href="https://www.freepik.com" title="Freepik">Freepik</a> from <a href="https://www.flaticon.com/" title="Flaticon">www.flaticon.com</a></div>
            <div>•</div>
            <div>Website made by Chris Luttio</div>
        </div>
    </SpanningBar>
)